// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/ellipsis-vertical.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/ellipsis-vertical'

import { Icon, type IconComponentProps } from '../icon'

export const EllipsisVerticalIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
